import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-refresh-icon',
  imports: [],
  templateUrl: './refresh-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './refresh-icon.component.scss',
})
export class RefreshIconComponent {}
